import React from 'react'
import { Container, Box, Typography, IconButton } from '@mui/material'
import { ArrowBack } from '@mui/icons-material'
import { useNavigate } from 'react-router-dom'
import CodingVersionHistory from '../components/mrd/MedicalCoding/CodingVersionHistory'

export const CodingVersionHistoryPage = () => {
  const navigate = useNavigate()

  return (
    <Container maxWidth="xl">
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
        <IconButton onClick={() => navigate(-1)} sx={{ mr: 2 }}>
          <ArrowBack />
        </IconButton>
        <Box>
          <Typography variant="h4" fontWeight={600}>
            Coding Version History
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Track all changes and versions of medical coding records
          </Typography>
        </Box>
      </Box>
      
      <CodingVersionHistory />
    </Container>
  )
}

